import type { ReactNode } from "react";

/**
 * Le sur-titre au-dessus d'un `h1` : petites capitales espacées, couleur d'action.
 *
 * Une primitive parce qu'il était écrit deux fois à la main (porte à code et page
 * de partage), avec les mêmes quatre classes : deux copies finissent toujours par
 * diverger.
 */
export function Eyebrow({ children }: { children: ReactNode }) {
	return <p className="t-caption-strong uppercase tracking-[0.14em] text-mg-action">{children}</p>;
}
